module.exports = __webpack_public_path__ + "img/DSCF6209.15b37b51.jpg";